<template>
  <div class="col-sm-6">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Horizontal Scroll</h3>
      </div>
      <div class="card-body">
        <div class="scroll-bar-wrap">
          <perfect-scrollbar class="horizontal-scroll scroll-demo" v-once :settings="options">

            <div class="horz-scroll-content">
              <div class="row">
                <div class="col-sm-3" v-for="item in data" :key="item">
                  <p>{{ item.desc }}</p>
                </div>

              </div>
            </div>

          </perfect-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import scrollable from "@/data/scrollable.json"
export default {
  data() {
    return {
      options: {
        maxScrollbarLength: 60,
        suppressScrollY: true,
        suppressScrollX: false
      },
      data: scrollable.horizontalscroll
    }
  }
}
</script>
<style scoped>
.ps {
  height: 300px;
}
</style>